import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { CrisisAlert } from 'Components/widgets/crisis-alert/CrisisAlert';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import URI from 'urijs';
type Props = {
  displayLoadMore: boolean;
  id?: string;
  link: {
    label: string;
    url: string;
  };
  message: string;
  resortId?: string;
};
export const CrisisAlertLine = ({ id, ...props }: Props) => {
  if (!props.message) {
    return null;
  }

  const linkUrl = new URI(props.link.url).addQuery('productId', props?.resortId).toString();
  return (
    <SiteContainer className="Line" id={id}>
      <CrisisAlert
        icon={ICONS.EXCLAMATION_POINT}
        message={props.message}
        hasSeeMore={props.displayLoadMore}
        linkLabel={props.link.label}
        linkUrl={linkUrl}
      />
    </SiteContainer>
  );
};
